import styled from "@emotion/styled";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const SC = {
  BodyHeader,
};

export default SC;
